
<template>
  <div class="container" style="min-height: 400px;">
    <div class="row my-2">
      <div class="col-lg-4 order-lg-1 text-center" style="margin-bottom: 1rem;">
        <img v-if="currentUser.avt" :src="currentUser.avt" class="mx-auto img-fluid d-block rounded-circle" width="260" height="260" alt="avatar">
        <svg v-else class="mx-auto img-fluid img-circle d-block" version="1.1" id="avatar" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 480 480" style="enable-background:new 0 0 480 480; width: 260px; height: 260px;" xml:space="preserve"><g><g>
          <path d="M240,0C107.664,0,0,107.664,0,240c0,57.96,20.656,111.184,54.992,152.704c0.088,0.12,0.096,0.272,0.192,0.384,c24.792,29.896,55.928,52.816,90.624,67.624c0.4,0.168,0.792,0.352,1.192,0.52c2.808,1.184,5.648,2.28,8.496,3.352
              c1.12,0.424,2.24,0.856,3.376,1.264c2.456,0.88,4.928,1.712,7.416,2.512c1.592,0.512,3.184,1.016,4.792,1.496,c2.2,0.656,4.408,1.288,6.632,1.888c1.952,0.528,3.92,1.016,5.888,1.488c1.992,0.48,3.992,0.96,6,1.384
              c2.24,0.48,4.504,0.904,6.776,1.32c1.824,0.336,3.64,0.688,5.48,0.984c2.52,0.408,5.056,0.728,7.6,1.056,c1.64,0.208,3.272,0.448,4.92,0.624c2.88,0.304,5.784,0.52,8.696,0.72c1.352,0.096,2.696,0.24,4.056,0.312
              c4.248,0.24,8.544,0.368,12.872,0.368s8.624-0.128,12.888-0.352c1.36-0.072,2.704-0.216,4.056-0.312,c2.912-0.208,5.816-0.416,8.696-0.72c1.648-0.176,3.28-0.416,4.92-0.624c2.544-0.328,5.08-0.648,7.6-1.056
              c1.832-0.296,3.656-0.648,5.48-0.984c2.264-0.416,4.528-0.84,6.776-1.32c2.008-0.432,4-0.904,6-1.384,c1.968-0.48,3.936-0.968,5.888-1.488c2.224-0.592,4.432-1.232,6.632-1.888c1.608-0.48,3.2-0.984,4.792-1.496
              c2.488-0.8,4.96-1.632,7.416-2.512c1.128-0.408,2.248-0.84,3.376-1.264c2.856-1.072,5.688-2.176,8.496-3.352,c0.4-0.168,0.792-0.352,1.192-0.52c34.688-14.808,65.832-37.728,90.624-67.624c0.096-0.112,0.104-0.272,0.192-0.384
              C459.344,351.184,480,297.96,480,240C480,107.664,372.336,0,240,0z M337.256,441.76c-0.12,0.056-0.232,0.12-0.352,0.176,c-2.856,1.376-5.76,2.672-8.688,3.936c-0.664,0.28-1.32,0.568-1.984,0.848c-2.56,1.072-5.152,2.088-7.76,3.064
              c-1.088,0.408-2.176,0.808-3.272,1.192c-2.312,0.824-4.632,1.616-6.976,2.368c-1.456,0.464-2.92,0.904-4.384,1.336,c-2.08,0.624-4.168,1.224-6.28,1.784c-1.776,0.472-3.568,0.904-5.36,1.328c-1.88,0.448-3.752,0.904-5.648,1.304
              c-2.072,0.44-4.16,0.816-6.24,1.192c-1.688,0.312-3.368,0.64-5.072,0.912c-2.344,0.368-4.712,0.664-7.072,0.96,c-1.496,0.192-2.984,0.416-4.496,0.576c-2.696,0.288-5.416,0.472-8.128,0.664c-1.208,0.08-2.408,0.216-3.632,0.28
              c-3.96,0.208-7.928,0.32-11.912,0.32s-7.952-0.112-11.904-0.32c-1.216-0.064-2.416-0.192-3.632-0.28,c-2.72-0.184-5.432-0.376-8.128-0.664c-1.512-0.16-3-0.384-4.496-0.576c-2.36-0.296-4.728-0.592-7.072-0.96
              c-1.704-0.272-3.384-0.6-5.072-0.912c-2.088-0.376-4.176-0.76-6.24-1.192c-1.896-0.4-3.776-0.856-5.648-1.304,c-1.792-0.432-3.584-0.856-5.36-1.328c-2.104-0.56-4.2-1.168-6.28-1.784c-1.464-0.432-2.928-0.872-4.384-1.336
              c-2.344-0.752-4.672-1.544-6.976-2.368c-1.096-0.392-2.184-0.792-3.272-1.192c-2.608-0.976-5.2-1.992-7.76-3.064,c-0.664-0.272-1.312-0.56-1.976-0.84c-2.928-1.256-5.832-2.56-8.696-3.936c-0.12-0.056-0.232-0.112-0.352-0.176
              c-27.912-13.504-52.568-32.672-72.576-55.952c15.464-56.944,59.24-102.848,115.56-121.112c1.112,0.68,2.272,1.288,3.416,1.928,c0.672,0.376,1.336,0.776,2.016,1.136c2.384,1.264,4.8,2.448,7.272,3.512c1.896,0.832,3.856,1.536,5.808,2.256
              c0.384,0.136,0.768,0.288,1.152,0.424c10.848,3.84,22.456,6.04,34.6,6.04s23.752-2.2,34.592-6.04,c0.384-0.136,0.768-0.288,1.152-0.424c1.952-0.72,3.912-1.424,5.808-2.256c2.472-1.064,4.888-2.248,7.272-3.512
              c0.68-0.368,1.344-0.76,2.016-1.136c1.144-0.64,2.312-1.248,3.432-1.936c56.32,18.272,100.088,64.176,115.56,121.112,C389.824,409.08,365.168,428.248,337.256,441.76z M152,176c0-48.52,39.48-88,88-88s88,39.48,88,88
              c0,30.864-16.008,58.024-40.128,73.736c-3.152,2.048-6.432,3.88-9.8,5.48c-0.4,0.192-0.792,0.392-1.192,0.576,c-23.168,10.536-50.592,10.536-73.76,0c-0.4-0.184-0.8-0.384-1.192-0.576c-3.376-1.6-6.648-3.432-9.8-5.48
              C168.008,234.024,152,206.864,152,176z M421.832,370.584c-18.136-53.552-59.512-96.832-112.376-117.392,C330.6,234.144,344,206.64,344,176c0-57.344-46.656-104-104-104s-104,46.656-104,104c0,30.64,13.4,58.144,34.552,77.192
              c-52.864,20.568-94.24,63.84-112.376,117.392C31.672,333.792,16,288.704,16,240C16,116.488,116.488,16,240,16s224,100.488,224,224,C464,288.704,448.328,333.792,421.832,370.584z"/></g></g>
        </svg>
        <!-- v-b-tooltip.hover.top="'Change your avatar'"  -->
        <photo-upload 
          ptext="Change avatar" 
          pclass="btn btn-outline-success btn-sm" 
          pstyle="margin-top: 0.5rem;"
          paccept="image/jpeg, image/png"
          pminwidth=260
          pminheight=260
          pmaxsize=5242880
          @ok:upload="handleSubmitAvatar" 
        ></photo-upload>
      </div>
      <div class="col-lg-8 order-lg-2">
        <ul class="nav nav-tabs">
          <li class="nav-item"><a href="" data-target="#profile" data-toggle="tab" class="nav-link active">Profile</a></li>
          <li class="nav-item"><a href="" data-target="#changePW" data-toggle="tab" class="nav-link">Change password</a></li>
          <!-- <li class="nav-item"><a href="" data-target="#messages" data-toggle="tab" class="nav-link">Messages <span class="badge badge-primary">9</span></a></li> -->
        </ul>
        <div class="tab-content py-4">
          <div class="tab-pane active" id="profile">
            <div class="row">
              <div class="col-md-6">
                <h5 class="mb-3">Your Profile</h5>
                <!-- <p><strong>Id: </strong><span>{{currentUser.id}}</span></p> -->
                <p><strong>Email: </strong><span>{{currentUser.email}}</span></p>
                <!-- <p v-if="isAdmin"><strong>Role: </strong><span>{{currentUser.role}}</span></p> -->
                <p><strong>Name: </strong><span v-if="!editting">{{currentUser.name}}</span><span v-else><input type="text" v-model="name" placeholder="Add name"/></span></p>
                <p><strong>Bio: </strong><span v-if="!editting">{{currentUser.bio ? currentUser.bio : '...'}}</span><span v-else><input type="text" v-model="bio" placeholder="Add a bio"/></span></p>
                <div 
                  v-if="message" 
                  class="alert" 
                  :class="successful ? 'alert-success' : 'alert-danger'" 
                  role="alert">{{message}}</div>
                <button v-if="!editting" @click.prevent="editProfile" type="button" class="btn btn-outline-primary btn-sm" style="margin-right: 5px;">Edit</button>
                <button v-if="editting" @click.prevent="cancelProfile" :disabled="loading" type="button" class="btn btn-outline-secondary btn-sm" style="margin-right: 5px;">Cancel</button>
                <button v-if="editting" @click.prevent="saveProfile" :disabled="loading" type="button" class="btn btn-outline-success btn-sm" style="margin-right: 5px;">Save</button>
                <hr>
              </div>
              <div class="col-md-6">
                <h6>Top 20 Your Tags</h6>
                <div v-if="social.tags && social.tags.length > 0">
                  <a v-for="t in social.tags" :key="t.id" :href="'/tag/'+linkTag(t.name, t.id)" class="badge badge-dark badge-pill" style="margin-right: 5px; padding-bottom: 4px;">{{t.name}}</a>
                </div>
                <hr>
                <span class="badge badge-primary" style="margin-right: 5px;"><font-awesome-icon icon="user" /> {{this.social.follower}} Followers</span>
                <span class="badge badge-success" style="margin-right: 5px;"><font-awesome-icon icon="user" /> {{this.social.following}} Following</span>
                <span class="badge badge-warning" style="margin-right: 5px;"><font-awesome-icon icon="file-word" /> {{this.social.totalPost}} Posts</span>
                <hr>
              </div>
              <!-- <div class="col-md-12">
                <h5 class="mt-2"><span class="fa fa-clock-o ion-clock float-right"></span> Recent Activity</h5>
                <table class="table table-sm table-hover table-striped">
                  <tbody>                                    
                    <tr>
                      <td>
                        <strong>Abby</strong> joined ACME Project Team in <strong>`Collaboration`</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Gary</strong> deleted My Board1 in <strong>`Discussions`</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Kensington</strong> deleted MyBoard3 in <strong>`Discussions`</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>John</strong> deleted My Board1 in <strong>`Discussions`</strong>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Skell</strong> deleted his post Look at Why this is.. in <strong>`Discussions`</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div> -->
            </div>
          </div>
          <div class="tab-pane" id="changePW">
            <form role="form" @submit.prevent="handleChangePW">
              <div 
                v-if="submitted && message" 
                class="alert" 
                :class="successful ? 'alert-success' : 'alert-danger'" 
                role="alert">{{message}}</div>
              <div class="form-group row">
                <label class="col-lg-3 col-form-label form-control-label">Current password</label>
                <div class="col-lg-9" style="margin-bottom: 10px;">
                  <input class="form-control" type="password" placeholder="Current password"
                    name="curpassword"
                    ref="curpassword"
                    v-model="curpassword" 
                    v-validate="'required|min:6|max:100'"
                    :class="submitted && errors.has('curpassword') ? 'is-invalid' : (submitted ? 'is-valid' : '')"
                  >
                  <span v-if="submitted && errors.has('curpassword')" class="help-block">{{errors.first('curpassword')}}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-lg-3 col-form-label form-control-label">New password</label>
                <div class="col-lg-9" style="margin-bottom: 10px;">
                  <input class="form-control" type="password" placeholder="New password"
                    name="password"
                    ref="password"
                    v-model="password" 
                    v-validate="'required|min:6|max:100'"
                    :class="submitted && errors.has('password') ? 'is-invalid' : (submitted ? 'is-valid' : '')"
                  >
                  <span v-if="submitted && errors.has('password')" class="help-block">{{errors.first('password')}}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-lg-3 col-form-label form-control-label">Confirm password</label>
                <div class="col-lg-9" style="margin-bottom: 10px;">
                  <input class="form-control" type="password" placeholder="Confirm new password"
                    name="repassword"
                    v-model="repassword" 
                    v-validate="'required|confirmed:password'" 
                    :class="submitted && errors.has('repassword') ? 'is-invalid' : (submitted ? 'is-valid' : '')"
                    data-vv-as="password"
                  >
                  <span v-if="submitted && errors.has('repassword')" class="help-block">{{errors.first('repassword')}}</span>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-lg-3 col-form-label form-control-label"></label>
                <div class="col-lg-9">
                  <button class="btn btn-primary" type="submit" :disabled="loading">
                    <span v-show="loading" class="spinner-border spinner-border-sm"></span> <span>Save Changes</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="tab-pane" id="messages">
            <div class="alert alert-info alert-dismissable">
              <a class="panel-close close" data-dismiss="alert">×</a> This is an <strong>.alert</strong>. Use this to show important messages to the user.
            </div>
            <table class="table table-hover table-striped">
              <tbody>                                    
                <tr>
                  <td>
                    <span class="float-right font-weight-bold">3 hrs ago</span> Here is your a link to the latest summary report from the..
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="float-right font-weight-bold">Yesterday</span> There has been a request on your account since that was..
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="float-right font-weight-bold">9/10</span> Porttitor vitae ultrices quis, dapibus id dolor. Morbi venenatis lacinia rhoncus. 
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="float-right font-weight-bold">9/4</span> Vestibulum tincidunt ullamcorper eros eget luctus. 
                  </td>
                </tr>
                <tr>
                  <td>
                    <span class="float-right font-weight-bold">9/4</span> Maxamillion ais the fix for tibulum tincidunt ullamcorper eros. 
                  </td>
                </tr>
              </tbody> 
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PhotoUpload from '@/components/PhotoUpload.vue';
import UploadService from "../services/upload.service";
import UserService from "../services/user.service";
import LinkMixin from "../mixins/link";

export default {
  name: 'Profile',
  mixins: [LinkMixin],
  components: {
    PhotoUpload,
	},
  data() {
    return {
      social: {},
      submitted: false,
      loading: false,
      successful: false,
      message: '',
      curpassword: '',
      password: '',
      repassword: '',
      editting: false,
      name: '',
      bio: '',
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    isAdmin() {
			if(this.currentUser && this.currentUser.role) {
				return this.currentUser.role == 'ADqrumXT2ga' || this.currentUser.role == 'RKxqtbyt58d';
			}
			return false;
		},
  },
  created () {
    // checkToken
		this.checkToken();
		// fetch the data when the view is created and the data is already being observed
		// https://router.vuejs.org/guide/advanced/data-fetching.html
    this.fetchData()
	},
  mounted() {
    if(!this.currentUser) {
      this.$router.push('/login');
    }
  },
  methods: {
    checkToken() {
			// console.log("In checkToken Profile");
			if(this.currentUser) {
				UserService.checkToken().then(data => {
					// console.log(data);
					if(data && data.err < 0) {
						this.$store.dispatch('auth/logout');
						window.location.reload();
					}
				});
			}
		},
    fetchData () {
			// if id exist them call method get post infomation.
			//console.log('this.$route.params.id: ' + this.$route.params.id);
			this.getSocial();
    },
    getSocial() {
      // console.log("In getSocial");
      UserService.getSocial().then(data => {
        // console.log(data);
        if(data && data.err >= 0) {
          this.social = data.social;
        }
      });
    },
    handleSubmitAvatar(filePhoto, handleProgress, handleSuccess, handleFailure) {
      // console.log("In handleSubmitAvatar");
			// Upload Photo...
			let formData = new FormData();
			formData.append("file", filePhoto);
      formData.append("action", "uavatar");
			UploadService.uploadAvatar(formData, event => {
        handleProgress(Math.round((100 * event.loaded) / event.total));
			}).then(data => {
				//this.message = data.msg;
				if(data && data.err >= 0) {
          let photo = data.photo;
          // update store local browser.
          let user = {
            id: this.currentUser.id,
            name: this.currentUser.name,
            email: this.currentUser.email,
            role: this.currentUser.role,
            bio: this.currentUser.bio,
            avt: photo.url,
            token: this.currentUser.token
          };
          this.$store.dispatch('auth/update', user);
					handleSuccess(data.msg);
				} else {
          handleFailure(data.msg);
				}
			});
    },
    resetChangePW() {
      this.submitted = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
      this.curpassword = '';
      this.password = '';
      this.repassword = '';
    },
    handleChangePW() {
      // console.log("In handleChangePW");
      this.submitted = true;
      this.loading = true;
      this.$validator.validateAll().then(isValid => {
        // console.log("isValid: " + isValid);
        if (isValid) {
          let formData = {
            "action": "chpw",
            "curpassword": this.curpassword,
            "password": this.password,
            "repassword": this.repassword
          };
          UserService.changePassword(formData).then(data => {
            this.message = data.msg;
            if (data && data.err >= 0) {
              this.successful = true;
              setTimeout(() => {
                this.resetChangePW();
              }, 3000);
            } else {
              this.successful = false;
              this.loading = false;
            }
          });
        } else {
          this.loading = false;
        }
      });
    },
    resetEditProfile() {
      this.editting = false;
      this.loading = false;
      this.successful = false;
      this.message = '';
    },
    editProfile() {
      // console.log("In editProfile");
      this.editting = true;
      this.name = this.currentUser.name;
      this.bio = this.currentUser.bio;
    },
    cancelProfile() {
      // console.log("In cancelProfile");
      this.editting = false;
    },
    saveProfile() {
      // console.log("In saveProfile");
      this.loading = true;
      // Validate input
      this.name = this.name.trim();
      this.bio = this.bio.trim();
      if (this.name === "") {
        this.message = "Name is required";
        this.successful = false;
        setTimeout(() => {
          this.loading = false;
          this.message = "";
        }, 2000);
        return;
      }
      if (this.name === this.currentUser.name && this.bio === this.currentUser.bio) {
        // console.log("In saveProfile nothing change");
        this.resetEditProfile();
        return;
      }
      let formData = {
        "action": "updateProfile",
        "name": this.name,
        "bio": this.bio
      };
      UserService.updateProfile(formData).then(data => {
        this.message = data.msg;
        if (data && data.err >= 0) {
          this.successful = true;
          // update store local browser.
          let user = {
            id: this.currentUser.id,
            name: this.name,
            email: this.currentUser.email,
            role: this.currentUser.role,
            bio: this.bio,
            avt: this.currentUser.avt,
            token: this.currentUser.token
          };
          this.$store.dispatch('auth/update', user);
          setTimeout(() => {
            this.resetEditProfile();
          }, 3000);
        } else {
          this.successful = false;
          this.loading = false;
        }
      });
    },
    // linkTag(name, id) {
		// 	return name.toLowerCase().replace(/[:?&]/g,'-').split(' ').join('-') + "-" + id;
		// },
  }
}
</script>